import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "copyright-container"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Plus = _resolveComponent("Plus");
  const _component_el_icon = _resolveComponent("el-icon");
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_upload = _resolveComponent("el-upload");
  const _component_el_form_item = _resolveComponent("el-form-item");
  const _component_el_date_picker = _resolveComponent("el-date-picker");
  const _component_el_input = _resolveComponent("el-input");
  const _component_el_row = _resolveComponent("el-row");
  const _component_el_form = _resolveComponent("el-form");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_cache[3] || (_cache[3] = _createElementVNode("div", {
    class: "tips"
  }, [_createElementVNode("span", {
    class: "tips-label"
  }, "*"), _createTextVNode(" 请确保素材内容原创，素材中所使用的字体、图形、影视剧照、海报、背景音乐、人物肖像权等均获得合法商业授权。 ")], -1)), _createVNode(_component_el_form, {
    ref: "formRef",
    "label-width": "120px",
    model: _ctx.copyrightForm,
    rules: _ctx.rules,
    class: "form-div"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_form_item, {
      label: "授权文件",
      prop: "authorizedFiles"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_upload, {
        class: "upload",
        ref: "upload",
        multiple: "",
        "http-request": $setup.fileUpload,
        "on-remove": $setup.handleRemove,
        "file-list": _ctx.fileList,
        "auto-upload": false
      }, {
        trigger: _withCtx(() => [_createVNode(_component_el_button, {
          type: "primary",
          plain: ""
        }, {
          default: _withCtx(() => [_createVNode(_component_el_icon, null, {
            default: _withCtx(() => [_createVNode(_component_Plus)]),
            _: 1
          }), _cache[2] || (_cache[2] = _createTextVNode(" 选取 授权文件 ", -1))]),
          _: 1
        })]),
        _: 1
      }, 8, ["http-request", "on-remove", "file-list"])]),
      _: 1
    }), _createVNode(_component_el_form_item, {
      label: "授权时间",
      prop: "authorizedTime"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_date_picker, {
        modelValue: _ctx.copyrightForm.authorizedTime,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _ctx.copyrightForm.authorizedTime = $event),
        type: "date",
        "value-format": "YYYY-MM-DD",
        format: "YYYY-MM-DD",
        placeholder: "授权时间"
      }, null, 8, ["modelValue"])]),
      _: 1
    }), _createVNode(_component_el_form_item, {
      label: "使用平台要求",
      prop: "useRequire"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_row, {
        class: "prop-val-row"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input, {
          type: "textarea",
          modelValue: _ctx.copyrightForm.useRequire,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _ctx.copyrightForm.useRequire = $event),
          placeholder: "请输入使用平台要求"
        }, null, 8, ["modelValue"])]),
        _: 1
      })]),
      _: 1
    })]),
    _: 1
  }, 8, ["model", "rules"])]);
}